module.exports = __webpack_public_path__ + "static/waiting-list-70f35b2f764441c7742066b7001075b5.svg";